/** Rings at the feet: round the player's target, and round the player (gold while meditating). */
import { ellipse } from '../drawKit';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'targetRing',
  layer: 'ground',
  order: 260,
  draw({ g, world: w, iso, ox, oy }) {
    g.lineWidth = 1;
    const tgt = w.get(w.player.targetId);
    if (!tgt || tgt.dead) return;
    const t = w.time;
    const [sx, sy] = iso.proj(tgt.x, tgt.y);
    const s = tgt.scale;
    const x = Math.round(sx + ox);
    const y = Math.round(sy + oy);
    g.strokeStyle = 'rgba(255,90,80,.85)';
    ellipse(g, x, y, 11 * s, 5 * s);
    g.stroke();
    for (let k = 0; k < 4; k++) {
      const a = t * 2 + (k * Math.PI) / 2;
      g.fillStyle = '#ffb0a0';
      g.fillRect(Math.round(x + Math.cos(a) * 11 * s), Math.round(y + Math.sin(a) * 5 * s), 1, 1);
    }
  },
});

registerRenderPass({
  id: 'playerRing',
  layer: 'ground',
  order: 270,
  draw({ g, world: w, iso, ox, oy }) {
    g.lineWidth = 1;
    const p = w.player;
    if (p.dead) return;
    const t = w.time;
    const [sx, sy] = iso.proj(p.x, p.y);
    const x = Math.round(sx + ox);
    const y = Math.round(sy + oy);
    const col = p.meditating ? '255,226,150' : '150,240,200';
    g.fillStyle = `rgba(${col},.1)`;
    ellipse(g, x, y, 15, 7.5);
    g.fill();
    g.strokeStyle = `rgba(${col},.6)`;
    g.stroke();
    g.strokeStyle = 'rgba(200,255,230,.28)';
    ellipse(g, x, y, 12, 6);
    g.stroke();
    for (let k = 0; k < 6; k++) {
      const a = t * (p.meditating ? 0.6 : 1.4) + (k * Math.PI) / 3;
      g.fillStyle = 'rgba(225,255,240,.95)';
      g.fillRect(Math.round(x + Math.cos(a) * 15), Math.round(y + Math.sin(a) * 7.5), 1, 1);
    }
  },
});
